import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(
    JSON.parse(localStorage.getItem("isLoggedIn")) || false
  );
  const [isSuperuser, setIsSuperuser] = useState(
    JSON.parse(localStorage.getItem("isSuperuser")) || false
  );
  const [isStaff, setIsStaff] = useState(
    JSON.parse(localStorage.getItem("isStaff")) || false
  );
  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );

  useEffect(() => {
    localStorage.setItem("isLoggedIn", JSON.stringify(isLoggedIn));
  }, [isLoggedIn]);

  useEffect(() => {
    localStorage.setItem("isSuperuser", JSON.stringify(isSuperuser));
  }, [isSuperuser]);

  useEffect(() => {
    localStorage.setItem("isStaff", JSON.stringify(isStaff));
  }, [isStaff]);

  useEffect(() => {
    localStorage.setItem("username", username);
  }, [username]);

  const login = (userUsername, userIsSuperuser, userIsStaff) => {
    setUsername(userUsername);
    setIsSuperuser(userIsSuperuser);
    setIsStaff(userIsStaff);
    setIsLoggedIn(true);
  };

  const logout = () => {
    // サーバー側セッションも破棄（失敗しても画面上はログアウトする）
    fetch(`${process.env.REACT_APP_API_URL}/api/logout/`, { method: "POST" }).catch(() => {});
    setIsLoggedIn(false);
    setIsSuperuser(false);
    setIsStaff(false);
    setUsername("");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("isSuperuser");
    localStorage.removeItem("isStaff");
    localStorage.removeItem("username");
  };

  const value = {
    isLoggedIn,
    setIsLoggedIn,
    isSuperuser,
    setIsSuperuser,
    isStaff,
    setIsStaff,
    username,
    setUsername,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
